const ESQUEMA_ACEITO = /^https?:\/\//i;
const TEM_ESQUEMA = /^[a-zA-Z][a-zA-Z0-9+.-]*:/;

export const enderecoSeguro = (bruto) => {
  const texto = String(bruto || '').trim();
  if (!texto) return null;
  if (ESQUEMA_ACEITO.test(texto)) return texto;
  if (TEM_ESQUEMA.test(texto)) return null;
  return `https://${texto.replace(/^\/+/, '')}`;
};

export const abrirLinkDeAtividade = (action, registrarParticipacao) => {
  const url = enderecoSeguro(action?.redirect_links?.[0]?.url);
  if (!url) return;

  window.open(url, '_blank', 'noopener,noreferrer');

  if (action.id && registrarParticipacao) {
    registrarParticipacao({ action_id: action.id });
  }
};
